// extracted by mini-css-extract-plugin
export default {"mainContainer":"PureVideo_mainContainer__uT0oe","video":"PureVideo_video__7UDpl"};